import React, { useState, useEffect } from 'react';
import { getPromoterReport } from '../../api/campaign';

const MasterDataTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedGame, setSelectedGame] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const [selectedShop, setSelectedShop] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    var today = new Date().toISOString().split('T')[0];
    fetchData(today);
    setSelectedDate(today);
    console.log(today);
  }, []);

  useEffect(() => {
    applyFilters();
  }, [data, selectedGame, selectedTeam, selectedShop]);

  const fetchData = async (date) => {
    try {
      setLoading(true);
      setData(await getPromoterReport(date));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    if (newDate) {
      fetchData(newDate);
    }
  };

  const applyFilters = () => {
    let filtered = [...data];

    if (selectedGame) {
      filtered = filtered.filter(item => item.g === selectedGame);
    }

    if (selectedTeam) {
      filtered = filtered.filter(item => item.t_n === selectedTeam);
    }

    if (selectedShop) {
      filtered = filtered.filter(item => item.s_n === selectedShop);
    }

    setFilteredData(filtered);
  };

  const getUniqueValues = (key) => {
    return [...new Set(data.map(item => item[key]))].filter(Boolean).sort();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-6">Data Report</h2>

      {/* Filters */}
      <div className="mb-6 flex gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filter by Date
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => handleDateChange(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filter by Brand
          </label>
          <select
            value={selectedGame}
            onChange={(e) => setSelectedGame(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Games</option>
            {getUniqueValues('g').map(game => (
              <option key={game} value={game}>{game}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filter by Team Name
          </label>
          <select
            value={selectedTeam}
            onChange={(e) => setSelectedTeam(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {/* Teams come from the data itself. The old hardcoded Team 1-16
                list was campaign 1's and matches nothing in this campaign. */}
            <option value="">All Teams</option>
            {getUniqueValues('t_n').map(team => (
              <option key={team} value={team}>{team}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filter by Shop Name
          </label>
          <select
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Shops</option>
            {getUniqueValues('s_n').map(shop => (
              <option key={shop} value={shop}>{shop}</option>
            ))}
          </select>
        </div>

        {(selectedGame || selectedTeam || selectedShop) && (
          <div className="flex items-end">
            <button
              onClick={() => {
                setSelectedGame('');
                setSelectedTeam('');
                setSelectedShop('');
              }}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* Results Count */}
      <div className="mb-4 text-sm text-gray-600">
        Showing {filteredData.length} of {data.length} records
      </div>

      {/* Table */}
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-xs text-left text-gray-500">
          <thead className="text-[10px] text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="px-2 py-2 sticky left-0 bg-gray-50 z-10">Team</th>
              <th scope="col" className="px-2 py-2 sticky left-[60px] bg-gray-50 z-10">Shop Name</th>
              <th scope="col" className="px-2 py-2">Brand</th>
              <th scope="col" className="px-2 py-2">Date</th>
              <th scope="col" className="px-2 py-2">Time</th>
              <th scope="col" className="px-1 py-2 text-center border-l-2 border-gray-300" colSpan="6">First Half</th>
              <th scope="col" className="px-1 py-2 text-center border-l-2 border-gray-300" colSpan="6">Second Half</th>
              <th scope="col" className="px-1 py-2 text-center border-l-2 border-gray-300" colSpan="6">Third Half</th>
              <th scope="col" className="px-1 py-2 text-center border-l-2 border-gray-300" colSpan="6">Total</th>
            </tr>
            <tr className="text-[10px] text-gray-700 uppercase bg-gray-100">
              <th colSpan="5" className="sticky left-0 bg-gray-100"></th>
              <th className="px-1 py-1 text-center border-l-2 border-gray-300">Ex</th>
              <th className="px-1 py-1 text-center">B5</th>
              <th className="px-1 py-1 text-center">CR</th>
              <th className="px-1 py-1 text-center">Oth</th>
              <th className="px-1 py-1 text-center">Bills</th>
              <th className="px-1 py-1 text-center">Amt</th>
              <th className="px-1 py-1 text-center border-l-2 border-gray-300">Ex</th>
              <th className="px-1 py-1 text-center">B5</th>
              <th className="px-1 py-1 text-center">CR</th>
              <th className="px-1 py-1 text-center">Oth</th>
              <th className="px-1 py-1 text-center">Bills</th>
              <th className="px-1 py-1 text-center">Amt</th>
              <th className="px-1 py-1 text-center border-l-2 border-gray-300">Ex</th>
              <th className="px-1 py-1 text-center">B5</th>
              <th className="px-1 py-1 text-center">CR</th>
              <th className="px-1 py-1 text-center">Oth</th>
              <th className="px-1 py-1 text-center">Bills</th>
              <th className="px-1 py-1 text-center">Amt</th>
              <th className="px-1 py-1 text-center border-l-2 border-gray-300">Ex</th>
              <th className="px-1 py-1 text-center">B5</th>
              <th className="px-1 py-1 text-center">CR</th>
              <th className="px-1 py-1 text-center">Oth</th>
              <th className="px-1 py-1 text-center">Bills</th>
              <th className="px-1 py-1 text-center">Amt</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="29" className="px-6 py-4 text-center text-gray-500">
                  No data found
                </td>
              </tr>
            ) : (
              filteredData.map((row, index) => (
                <tr key={row.id || index} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap sticky left-0 bg-white">
                    {row.t_n}
                  </td>
                  <td className="px-2 py-2 sticky left-[60px] bg-white">{row.s_n}</td>
                  <td className="px-2 py-2 capitalize">{row.g}</td>
                  <td className="px-2 py-2 whitespace-nowrap">{row.dt.split('T')[0]}</td>
                  <td className="px-2 py-2">{row.t_s}</td>

                  {/* First Half */}
                  <td className="px-1 py-2 text-center border-l-2 border-gray-200">{row.ex || 0}</td>
                  <td className="px-1 py-2 text-center">{row.b5 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.cr || 0}</td>
                  <td className="px-1 py-2 text-center">{row.oth || 0}</td>
                  <td className="px-1 py-2 text-center">{row.bill_c || 0}</td>
                  <td className="px-1 py-2 text-center">{parseFloat(row.amo || 0).toFixed(2)}</td>

                  {/* Second Half */}
                  <td className="px-1 py-2 text-center border-l-2 border-gray-200">{row.ex_2 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.b5_2 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.cr_2 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.oth_2 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.bill_c_2 || 0}</td>
                  <td className="px-1 py-2 text-center">{parseFloat(row.amo_2 || 0).toFixed(2)}</td>

                  {/* Third Half */}
                  <td className="px-1 py-2 text-center border-l-2 border-gray-200">{row.ex_3 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.b5_3 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.cr_3 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.oth_3 || 0}</td>
                  <td className="px-1 py-2 text-center">{row.bill_c_3 || 0}</td>
                  <td className="px-1 py-2 text-center">{parseFloat(row.amo_3 || 0).toFixed(2)}</td>

                  {/* Total */}
                  <td className="px-1 py-2 text-center font-semibold border-l-2 border-gray-200 bg-gray-50">{row.ex_t || 0}</td>
                  <td className="px-1 py-2 text-center font-semibold bg-gray-50">{row.b5_t || 0}</td>
                  <td className="px-1 py-2 text-center font-semibold bg-gray-50">{row.cr_t || 0}</td>
                  <td className="px-1 py-2 text-center font-semibold bg-gray-50">{row.oth_t || 0}</td>
                  <td className="px-1 py-2 text-center font-semibold bg-gray-50">{row.bill_c_t || 0}</td>
                  <td className="px-1 py-2 text-center font-semibold bg-gray-50">{parseFloat(row.amo_t || 0).toFixed(2)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MasterDataTable;